<template>
  <div id="inner_card"
    :class="[(type === 'app' ? 'black-outset-1' : 'black-outset'), (this.$lang === 'ar' ? 'inner-card-right' : 'inner-card-left')]"
    :style="[type === 'app' ? { 'background': 'url( ' + item.background + ') no-repeat' } : '']">
    <div class="white-inset radius-30 w-100 h-100"
      :class="type === 'app' && !over ? 'black-gradient' : type === 'app' && over ? 'gradient-over-app' : ''"
      @mouseover="over = true" @mouseleave="over = false" :style="type === 'app' ? { 'pointer-events': 'auto' } : {}">
      <Loader v-if="item.id === -1" />
      <div class="h-100" v-if="item.id !== -1">
        <img @click="openDialog" :class="[this.$lang === 'ar' ? 'share-button-ar' : 'share-button-en', 'share-button']"
          src="../../assets/icons/share.svg" v-if="type !== 'app'">
        <div class="card-container" :class="type === 'app' ? '' : cardPadding()">
          <div class="card-icon app-card-con" v-if="type === 'app'" :style="!over ? { 'height': '11rem' } : {}">
            <img ref="appIcon" :src="item.icon" style="width: 65px; height: auto">
          </div>
          <div :class="[this.$lang === 'ar' ? 'bold-ar' : 'bold-en', 'card-title mt-xl-2']">
            {{ item.title }}
          </div>
          <div v-if="type === 'bundle'" :class="type === 'bundle' && 'fixed-height'" class="mt-2 pt-1 inner-card-content">
            <div class="card-description small-padding w-100" v-for="(item1, i) in item.description" :key="i">
              <div class="bundle-value" v-if="!item1.value.includes('null')">{{ item1.value }}</div>
              <div class="bundle-description" v-if="!item1.value.includes('null')">{{ item1.desc }}</div>
            </div>
          </div>
          <div v-else-if="type === 'app' && over" v-html="item.description"
            class="card-description white-font click-address">
            <!--              {{item.description}}-->
          </div>
          <div v-else-if="type === 'app' && !over" class="card-description white-font click-address"></div>
          <div class="card-description" v-else
            :class="[type === 'offers' ? 'offers-card-description' : '', type === 'basic' ? 'clamp-7' : '']"
            :style="type === 'feature' ? 'margin-top: 4rem' : ''">
            {{ item.description }}
          </div>
          <div v-if="type === 'feature' || (item.price !== '' && type === 'bundle') || type === 'offers'"
            :class="item.price !== '' && type === 'bundle' || type === 'offers' ? 'margin-top-1' : 'margin-top-4'"
            class="flex-center">
            <span class="price">{{ item.price }}</span>&nbsp;<span class="unit">{{ item.unit }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import bigInnerCard from '../../assets/images/inner-card.svg'
import innerCard from '../../assets/images/innerCard.png'
import gc from '../../utils/gc'
import Loader from '../LoaderBtn/Loader'
// import smallInnerCard from '../../assets/images/small-inner-card.svg'
import $ from 'jquery'
export default {
  name: 'InnerCard',
  components: { Loader },
  props: {
    bundleType: String,
    cardType: {
      type: String
    },
    data: {
      type: Object
    }
  },
  data () {
    return {
      over: false,
      type: 'basic',
      image: bigInnerCard,
      item: { title: '', description: '', icon: '', unit: '', price: '' },
      dialog: false
    }
  },
  created () {
    this.type = this.cardType
    this.item = this.data
    if (this.type === 'app') {
      this.image = innerCard
    }
  },
  mounted () {
    setTimeout(() => {
      this.$lang === 'ar' ? $('.card-title').css('font-family', 'Mtn-arabic-bold') : $('.card-title').css('font-family', 'Mtn-bold')
      this.$lang === 'ar' ? $('.bundle-value').css('font-family', 'Mtn-arabic-bold') : $('.bundle-value').css('font-family', 'Mtn-bold')
      this.$lang === 'ar' ? $('.bundle-description').css('font-family', 'Mtn-arabic-regular') : $('.bundle-description').css('font-family', 'Mtn-regular')
      this.$lang === 'ar' ? $('.card-description').css('font-family', 'Mtn-arabic-regular') : $('.card-description').css('font-family', 'Mtn-regular')
      this.$lang === 'ar' ? $('.unit').css('font-family', 'Mtn-arabic-bold') : $('.unit').css('font-family', 'Mtn-bold-italic')
      this.$lang === 'ar' ? $('.price').css('font-family', 'Mtn-arabic-bold') : $('.price').css('font-family', 'Mtn-bold')
      this.$lang === 'ar' ? $('.price').css('margin-bottom', '9px') : $('.price').css('margin-bottom', '4px')
    })
  },
  methods: {
    // getImageSize () {
    //   const image = this.$refs.appIcon
    //   const width = image.naturalWidth
    //   const height = image.naturalHeight
    //   if (width > height || width === height) {
    //     $('.card-icon' + this.item.id).css('width', '90px')
    //     $('.card-icon' + this.item.id).css('height', 'auto')
    //   } else {
    //     $('.card-icon' + this.item.id).css('width', 'auto')
    //     $('.card-icon' + this.item.id).css('height', '65px')
    //   }
    // },
    cardPadding () {
      // padding-top-3  / padding-top-1
      return (((this.type === 'bundle' && this.item.price === undefined) || this.type === 'feature') ? 'padding-top-3' : (this.type === 'bundle' && this.item.price !== undefined) ? 'padding-top-1' : this.type === 'offers' ? 'offer' : 'padding-top-7')
    },
    openDialog () {
      this.$store.state.sharing = true
      this.$store.state.sharedMessage = this.data.title
      if (this.type === 'bundle') {
        this.$store.state.sharingLink = `${gc.website}/bundle-details/${this.bundleType}/${this.data.id}`
        this.$store.state.sharedTitle = this.$t('shareDialog.shareBundle')
        this.$store.state.urlTitle = this.$t('shareDialog.bundle')
      } else if (this.type === 'offers') {
        this.$store.state.sharingLink = `${gc.website}/offer-details/${this.$store.state.offerType}/${this.data.id}`
        this.$store.state.sharedTitle = this.$t('shareDialog.shareOffer')
        this.$store.state.urlTitle = this.$t('shareDialog.offer')
      } else if (this.type === 'basic') { /* digital services slider */
        this.$store.state.sharingLink = `${gc.website}/service-details/${this.data.id}`
        this.$store.state.sharedTitle = this.$t('shareDialog.shareService')
        this.$store.state.urlTitle = this.$t('shareDialog.service')
      }
    }
  }
}
</script>
<style scoped>
.gradient-over-app {
  background-image: linear-gradient(to bottom, RGBA(0, 0, 0, 0.5), RGBA(0, 0, 0, 1)) !important;
  -moz-background-image: -moz-linear-gradient(to bottom, RGBA(0, 0, 0, 0.5), RGBA(0, 0, 0, 1)) !important;
  -o-background-image: -o-linear-gradient(to bottom, RGBA(0, 0, 0, 0.5), RGBA(0, 0, 0, 1)) !important;
  -webkit-background-image: -webkit-linear-gradient(to bottom, RGBA(0, 0, 0, 0.5), RGBA(0, 0, 0, 1)) !important;
}

.clamp-7 {
  -webkit-line-clamp: 7 !important;
}

.app-card-con {
  height: 8rem;
  display: flex;
  justify-content: center;
  align-items: flex-end;
  padding: 0 !important;
  transition: height .2s;
}

/*.bundle-card{*/
/*  height: 89%;*/
/*  display: flex;*/
/*  flex-direction: column;*/
/*  align-items: center;*/
/*  justify-content: space-between;*/
/*  padding-top: 20px !important;*/
/*}*/
.bundle-description {
  overflow: hidden;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1 !important;
  margin-bottom: .5rem !important;
  /* added */
}

.offers-card-description {
  -webkit-line-clamp: 5 !important;
}

.fixed-height {
  height: 175px;
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center;
}

.small-padding {
  padding: 0;
}

.bundle-value {
  font-style: italic;
}

.inner-card-right {
  right: 32.5px !important;
}

.inner-card-left {
  left: 34.5px !important;
}

.padding-top-1 {
  padding-top: 2rem !important;
  /* -- 2 -- */
}

.offer {
  padding: 1.8rem 0.2rem !important;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.padding-top-3 {
  padding-top: 2.8rem !important;
}

.padding-top-7 {
  padding-top: 5rem !important;
  /*-- 7 rem --*/
}

.margin-top-4 {
  margin-top: 4rem;
}

.margin-top-1 {
  margin-top: 0.7rem;
}

.inner-card-content {
  padding-top: 8px !important;
  margin-top: 10px;
}

.share-button-en {
  right: 25px;
}

.share-button-ar {
  left: 25px;
  transform: rotate(0deg) !important;
}

@media screen and (max-width: 1000px) {
  .padding-top-1 {
    padding-top: 2rem !important;
  }

  .offer {
    padding: 1.5rem 1.8rem !important;
  }

  .padding-top-3 {
    padding-top: 2.8rem !important;
  }

  .padding-top-7 {
    padding-top: 5rem !important;
  }

  .margin-top-4 {
    margin-top: 2rem;
  }

  .margin-top-1 {
    margin-top: 0.4rem;
  }

  .share-button-en {
    right: 23px;
  }

  .share-button-ar {
    left: 23px;
    transform: rotate(180deg);
  }

  .card-container {
    padding-left: 10px;
    padding-right: 10px;
  }
}

@media (max-width: 500px) {
  .fixed-height {
    height: 160px;
  }

  .small-padding {
    padding: 0 20px;
  }

  .inner-card-right {
    right: 28.5px !important;
  }

  .inner-card-left {
    left: 28.5px !important;
  }

  /* .card-title{
    margin-bottom: 0 !important ;
    font-size: 18px;
    padding-top: 8px;
  } */
  .card-title {
    white-space: normal !important;
    word-wrap: break-word !important;
    overflow-wrap: break-word !important;
    display: block !important;
    height: auto !important;
    overflow: visible !important;
    -webkit-line-clamp: unset !important;
    line-height: 1.3 !important;
    min-height: auto !important;
    text-overflow: unset !important;
  }

  /* Also check if there's any parent container limiting the height */
  .card-container {
    height: auto !important;
    min-height: auto !important;
  }

  .bundle-value {
    font-size: 14px;
  }

  .bundle-description {
    font-size: 12px;
  }

  #inner_card .share-button {
    width: 16px;
    height: 16px;
  }

  .bundle-description {
    overflow: hidden;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 1 !important;
  }
}
</style>
<!--overflow: hidden;-->
<!--display: -webkit-box;-->
<!-- -webkit-box-orient: vertical;-->
<!-- -webkit-line-clamp: 3;-->
<!--}-->
